import React from 'react';
import { X } from 'lucide-react';

export interface FilterChip {
  id: string;
  type: 'category' | 'type' | 'price' | 'stock' | 'country' | 'region' | 'grape' | 'producer';
  label: string;
  value: string;
}

interface FilterChipsProps {
  chips: FilterChip[];
  onRemove: (chipId: string) => void;
  onClearAll: () => void;
}

export const FilterChips: React.FC<FilterChipsProps> = React.memo(
  ({ chips, onRemove, onClearAll }) => {
    if (chips.length === 0) return null;

    return (
      <div className="flex flex-wrap items-center gap-2 px-4 py-3 bg-gray-50 border-b border-gray-100 max-w-full">
        <span className="text-xs font-medium text-gray-500 mr-1">Filters:</span>

        {chips.map((chip) => (
          <div
            key={chip.id}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-wine/10 text-wine text-sm font-medium animate-scale-in"
          >
            <span className="capitalize">{chip.label}</span>
            <button
              onClick={() => onRemove(chip.id)}
              className="ml-0.5 p-0.5 rounded-full hover:bg-wine/20 transition-colors"
              aria-label={`Remove ${chip.label} filter`}
            >
              <X size={14} />
            </button>
          </div>
        ))}

        {chips.length > 1 && (
          <button
            onClick={onClearAll}
            className="text-xs text-wine hover:text-wine-dark font-medium ml-2 hover:underline transition-colors"
          >
            Clear All
          </button>
        )}
      </div>
    );
  }
);

FilterChips.displayName = 'FilterChips';
